export default "__VITE_ASSET__BMoaynbP__"